export default __webpack_public_path__ + "media/pizza.364016e47cd712861060977f020ccb88.webp";